/**
 * LocalStorage helpers for persisting the notifications panel open/closed state.
 *
 * Isolated into a separate module so it can be unit-tested without importing
 * React components or MUI.
 */

const PANEL_STORAGE_KEY = "boxhub.notifications.panel.open";

/**
 * Reads the panel open state from localStorage.
 * Defaults to false when the key is absent or unparseable.
 */
export function readPanelOpenState(): boolean {
    try {
        const raw = localStorage.getItem(PANEL_STORAGE_KEY);
        return raw === "true";
    } catch {
        return false;
    }
}

/**
 * Writes the panel open state to localStorage.
 * Silently ignores storage errors (e.g. quota exceeded, restricted access).
 */
export function writePanelOpenState(isOpen: boolean): void {
    try {
        localStorage.setItem(PANEL_STORAGE_KEY, String(isOpen));
    } catch {
        // Silently ignore quota or security errors
    }
}
